module.exports = __webpack_public_path__ + "static/brick-door-crop-8b4c14342fb260e35b10db401f768566.png";